import QueryParamsUtil from 'api/utils/query-params-util'
import axios from 'axios'

const API_PATH = 'api/v2/admins/cms/blog_posts'

const CmsBlogPostsApiV2 = {

  /**
   * Create a Cms for Blog Post
   * Invoke `POST api/v2/admins/cms/blog_posts'
   */
  create: async (payload) => {
    const path = API_PATH

    const response = axios.post(path, payload)

    return response
  },
  /**
   * Update a Cms for Blog Post
   * Invoke `PATCH api/v2/admins/cms/blog_posts/:id'
   * @param {string} id CMS Blog Post Id
   */
  update: async (id, payload) => {
    const path = `${API_PATH}/${id}`

    const response = axios.patch(path, payload)

    return response
  },
  /**
   * Show CMS Blog Post by specific id
   * Invoke `GET api/v2/admins//cms/blog_posts/:id`
   * @param {number} id CMS Blog Post Id
   */
  getSingle: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = await axios.get(path)

    return response
  },
  /*
   * Get list of Cms Blog Posts
   * Invoke `GET api/v2/admins/cms/blog_posts'
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  }

}

export default CmsBlogPostsApiV2
